import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd";
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

const KidsDetails = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "employeeKidsDetail",
  });

  const kidsDetails = watch("employeeKidsDetail") || [];

  const addKidsDetailsRow = () => {
    const newKid = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      kidName: "",
      dateOfBirth: "",
      gender: "",
      schoolName: "",
      grade: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("employeeKidsDetail", [...kidsDetails, newKid]);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addKidsDetailsRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Kid Name</th>
              <th>Gender</th>
              <th>DOB</th>
              <th>School Name</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {kidsDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`employeeKidsDetail[${index}].kidName`}
                      type="text"
                      placeholder="Kid Name"
                      className={`form-control ${
                        errors?.employeeKidsDetail?.[index]?.kidName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`employeeKidsDetail[${index}].gender`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.employeeKidsDetail?.[index]?.gender
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={genderOptions}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "employeeKidsDetail[${index}].gender",
                          selectedOption
                        );
                        trigger("employeeKidsDetail[${index}].gender");
                      }}
                      defaultValue={watch(
                        "employeeKidsDetail[${index}].gender"
                      )}
                    />
                  </td>

                  <td>
                    <Input
                      name={`employeeKidsDetail[${index}].dateOfBirth`}
                      type="date"
                      placeholder="DOB"
                      className={`form-control ${
                        errors?.employeeKidsDetail?.[index]?.dateOfBirth
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`employeeKidsDetail[${index}].dateOfBirth`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`employeeKidsDetail[${index}].schoolName`}
                      type="text"
                      placeholder="School Name"
                      className={`form-control ${
                        errors?.employeeKidsDetail?.[index]?.schoolName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`employeeKidsDetail[${index}].grade`}
                      type="text"
                      placeholder="Grade"
                      className={`form-control ${
                        errors?.employeeKidsDetail?.[index]?.grade
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default KidsDetails;
